import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", { d: "M8.5 12c0-.786.26-1.512.697-2.096L11.293 12l-2.096 2.096A3.484 3.484 0 018.5 12zM14.096 9.197A3.484 3.484 0 0012 8.5c-.786 0-1.512.26-2.096.697L12 11.293l2.096-2.096zM12 12.707l2.096 2.096A3.484 3.484 0 0112 15.5c-.786 0-1.512-.26-2.096-.697L12 12.707zM12.707 12l2.096-2.096c.438.584.697 1.31.697 2.096s-.26 1.512-.697 2.096L12.707 12z" }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M19 5H5v14h14V5zM8.484 14.809l-1.338 1.338a.5.5 0 10.708.707l1.337-1.338c.77.616 1.746.984 2.809.984a4.48 4.48 0 002.809-.984l1.337 1.338a.5.5 0 00.708-.707l-1.338-1.338A4.48 4.48 0 0016.5 12a4.481 4.481 0 00-.984-2.809l1.338-1.337a.5.5 0 00-.708-.708L14.81 8.484A4.48 4.48 0 0012 7.5a4.481 4.481 0 00-2.809.984L7.854 7.146a.5.5 0 10-.708.708L8.484 9.19A4.481 4.481 0 007.5 12a4.48 4.48 0 00.984 2.809z",
      "clip-rule": "evenodd"
    })
  ]))
}